<script>
	var classService = require('services/classService'),
		page = require('page'),
		pubsub = require('events/pubsub'),
		userContext = require('core/userContext'),
		utilities = require('../../utilities'),
		model = require('model/model');

	module.exports = {
		methods: {
			selectRosterType: function (type) {
				const data = model.get('newClass');
				const returnToProduct = model.get('returnToProduct');

				if (!data) {
					page('/class-admin');
					model.remove('classCode');
					model.set('classAdmin', 'active');
					return;
				}

				if (type === 'student') {
					classService
						.createClass({
							n: data.name,
							g: String(data.grade),
							rt: type
						})
						.then(function (result) {
							model.remove('newClass');

							page('/class-admin');
							model.set('classAdmin', 'roster');
							model.set('classCode', result.cc);
							if (returnToProduct) {
								model.set('returnToProduct', returnToProduct);
							}

							pubsub.publish('class-creation-complete');

							pubsub.publish('message-success', 'Class "' + data.name + '" created');

							userContext.setToken(result.token);
						});
				} else if (type === 'teacher') {
					utilities.openModal('#modal-add-tr-students');
				}
			}
		},

		mounted() {
			if (!model.get('newClass')) {
				page('/class-admin');
			}
		}
	};
</script>
<template>
	<main class="padding-top-bottom-large text-centered">
		<h1>Invite Students to Class</h1>
		<h4>Select an option to add students to this class. Only one option can be used.</h4>
		<div class="grid centered">
			<div class="main alternate main-box grid-col-5">
				<h1>GOOGLE SIGN IN</h1>
				<div
					class="content text-left"
					style="min-height: 8rem">
					<table class="no-borders">
						<tr rowspan="2">
							<td
								rowspan="2"
								class="font-large padding-none">
								1
							</td>
						</tr>
						<tr>
							<td></td>
							<td>Students sign in with their own Google account.</td>
						</tr>
						<tr rowspan="2">
							<td
								rowspan="2"
								class="font-large padding-none">
								2
							</td>
						</tr>
						<tr>
							<td></td>
							<td>Students access this class using a class code you give them.</td>
						</tr>
					</table>
				</div>
				<div
					class="content"
					style="min-height: 10rem">
					<h2>BEST OPTION FOR</h2>
					<ul class="text-left">
						<li>Students with Google accounts.</li>
					</ul>
					<button
						v-on:click.prevent="selectRosterType('student')"
						class="button -full-width">
						Invite with Google
					</button>
				</div>
			</div>
			<div
				class="grid-col-2 font-large"
				style="min-height: 29.16rem; position: relative">
				<strong
					style="transform: translateX(-50%)"
					class="vertically-centered"
					>OR</strong
				>
			</div>
			<div class="main alternate main-box grid-col-5">
				<h1>ROSTER</h1>
				<div
					class="content text-left"
					style="min-height: 8rem">
					<table class="no-borders">
						<tr rowspan="2">
							<td
								rowspan="2"
								class="font-large padding-none">
								1
							</td>
						</tr>
						<tr>
							<td></td>
							<td>You add the students' names to the roster.</td>
						</tr>
						<tr rowspan="2">
							<td
								rowspan="2"
								class="font-large padding-none">
								2
							</td>
						</tr>
						<tr>
							<td></td>
							<td>Students access this class using a class code, and select their name.</td>
						</tr>
					</table>
				</div>
				<div
					class="content"
					style="min-height: 10rem">
					<h2>BEST OPTION FOR</h2>
					<ul class="text-left">
						<li>Students without Google accounts.</li>
					</ul>
					<button
						v-on:click.prevent="selectRosterType('teacher')"
						class="button -full-width">
						Invite with Roster
					</button>
				</div>
			</div>
		</div>
	</main>
</template>
